<nz-form-item>
    <nz-form-label>{{customField.name}}</nz-form-label>
    <nz-form-control>
        <nz-select [(ngModel)]="value" 
            [nzMode]="customField.isMultiSelect ? 'tags' : 'default'">
            <nz-option *ngFor="let enumValue of customField.enumValues" [nzValue]="enumValue" [nzLabel]="enumValue"></nz-option>
        </nz-select>
    </nz-form-control>
</nz-form-item>